import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CodeiumEditor } from "@codeium/react-code-editor";
import { useContext, useEffect, useState } from "react";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

const SqlData = () => {
  const { config, setConfig } = useContext(GraphConfigFormContext);
  const { t } = useTranslation();

  const [sqlRequest, setSqlRequest] = useState(
    config?.data_source.sqlRequest || ""
  );

  useEffect(() => {
    setSqlRequest(config?.data_source.sqlRequest || "");
  }, [config]);

  return (
    <div className="flex flex-col gap-4 w-full px-4 pt-4 pb-[100px]">
      <Card className="h-96">
        <CodeiumEditor
          height="100%"
          language={"sql"}
          theme="vs-light"
          value={sqlRequest}
          onChange={(value) => setSqlRequest(value || "")}
          options={{
            fontSize: 14,
            minimap: { enabled: false },
            wordWrap: "on",
          }}
        />
      </Card>
      <Button
        onClick={() =>
          setConfig({
            ...config,
            data_source: { ...config?.data_source, sqlRequest },
          } as any)
        }
      >
        {t("editor.graphConfig.sqlData.save")}
      </Button>
    </div>
  );
};

export default SqlData;
